export const formatRoleCategory = (category) => {
  if (!category) return;
  if (category === 'menu') return 'Visualizar menus';
  if (category === 'inspections') return 'Vistorias';
  if (category === 'settings') return 'Configurações do sistema';
  if (category === 'dashboard') return 'Dashboard';
};
